import { useQuery } from "@tanstack/react-query";

import { makeSelectQueryFromColumns } from "common";
import { resourceType, Space, SPACE_COLUMNS } from "types";

import { queryClient, supabase } from "../../services";

const querySpaces = async () => {
  const spaces = await supabase
    .from(resourceType.Spaces)
    .select<string, Space>(makeSelectQueryFromColumns(SPACE_COLUMNS));

  if (!spaces.data) {
    throw spaces.error;
  }

  return spaces.data;
};

export const GET_SPACES = "workspaces";

export const getSpaces = async () => {
  return queryClient.fetchQuery({
    queryKey: [GET_SPACES],
    queryFn: querySpaces
  });
};

export const useSpaces = () =>
  useQuery({
    queryKey: [GET_SPACES],
    queryFn: querySpaces
  });
